module.exports = __webpack_public_path__ + "img/homepage-banner.94c8c0db.jpg";